import Empty from '@/views/Empty';
import VehicleIndex from '@/views/pages/vehicle/Index';

import VehicleDetail from '@/views/pages/vehicle/Detail';
import VehicleDetailIndex from '@/views/pages/vehicle/detail/Index';
import VehicleActivity from '@/views/pages/vehicle/detail/Activity';

export default {
  path: 'vehicles',
  component: Empty,
  children: [
    {
      path: '',
      name: 'Vehicle',
      component: VehicleIndex,
    },
    {
      path: ':vehicleId',
      component: VehicleDetail,
      children: [
        {
          path: '',
          name: 'Vehicle Detail',
          component: VehicleDetailIndex,
        },
        {
          path: 'activity',
          name: 'Vehicle Activity',
          component: VehicleActivity,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/vehicle.js